import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiSendEmailVerification,
  apiEmailSignup,
} from '@dragonfruit/services/apis';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { getSignupEmail } from '@dragonfruit/redux/signup';
import * as actions from '@dragonfruit/redux/sendEmail';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
  ALERT_SYSTEMINFO_THEME,
} from '@dragonfruit/constants/alertBannerThemes';

export function* sendConfirmationEmail(action) {
  const { userId } = action.payload;
  try {
    const lastSentTime = yield select(actions.getLastMessageTime);
    const timeNow = Date.now() / 1000;

    if (lastSentTime && timeNow - lastSentTime < 30) {
      yield put(actions.sendConfirmationEmailSuccess());

      yield put(
        showAlertBanner({
          message: 'account.resendConfirmationEmailWait',
          theme: ALERT_SYSTEMINFO_THEME,
        })
      );

      return;
    }

    yield call(apiSendEmailVerification, {
      userId,
    });

    yield put(actions.sendConfirmationEmailSuccess());

    yield put(
      showAlertBanner({
        message: 'account.sendEmailSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(actions.sendConfirmationEmailError(err.message));

    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export function* resendEmailFlow() {
  try {
    const email = yield select(getSignupEmail);

    // only give email when resend on the same API with register
    const data = {
      email,
    };

    // don't need any response from this API
    yield call(apiEmailSignup, data);

    yield put(
      showAlertBanner({
        message: 'emailNotVerified:emailNotVerified.sendEmailSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    showAlertBanner({
      message: 'error:error.someThingWrong',
      theme: ALERT_ERROR_THEME,
    });
  }
}

export default function*() {
  yield all([
    takeLatest(actions.SEND_CONFIRMATION_EMAIL, sendConfirmationEmail),
    takeLatest(actions.RESEND_EMAIL, resendEmailFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/sendEmail.js